/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Greeting/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Greeting({
  children,
  viewPath = "/DesignSystem/DataVaxiomProfessionalView/Content/Details/Person/Greeting",
  onChange
  
}) {
let searchViewDetailsGreetingValueData = fromData.useDataValue({ viewPath,
context: 'search',
path: 'view_details.greeting',
})
let searchViewDetailsGreetingChangeData = fromData.useDataChange({ viewPath,
context: 'search',
path: 'view_details.greeting',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 disabled={true}
 data="search.view_details.greeting"
 value={searchViewDetailsGreetingValueData}
 onChange={searchViewDetailsGreetingChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Greeting"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}